export const PlanBMonitorConstants = {
    eventsPath: "/harmony-monitor/planb/events",
    contentType: "application/json",
    sourceParam: "differentiateDomainMarketing",
    templateIdSeparator: ";",
    emptyPlanBTemplateId: "empty Plan B",
    httpErrorMessagePrefix: "HTTP "
};
export const PlanBEventType = {
    PLAN_B: "planB",
    TIMEOUT: "timeout",
    HTTP_ERROR: "httpError"
};
